@if (subscription$ | async; as subscription) {
  @if (shouldShowLowMinutesWarning(subscription)) {
    <button 
      matButton="filled"
      class="low-minutes-toast" 
      [class.visible]="isVisible()" 
      [class.hidden]="!isVisible()"
      (click)="onToastClick($event)">
      <iconify-icon icon="mdi:information-outline" class="info-icon"></iconify-icon>
      <span class="toast-text">{{ getRemainingMinutes(subscription) }} {{ 'upgradePrompt.minutesLeft' | translate }}</span>
    </button>
  }
}
